module.exports = __webpack_public_path__ + "img/curve.fbd580f1.svg";